import Cookies from "js-cookie";
import { IPoliticAdapterResponse } from "../models/get-politic.model";
import User from "../models/User";
import { ACCESS_TOKEN } from "../util/constants/APP_RESERVED_NAME";
import { API_HEADER } from "../util/constants/HEADERS";
import { PdfGeneratorService } from "./pdf-generator.service";

const adapterUserCompleteName = (user: any) => {
    const father_lastname = user.father_lastname === null ? "" : user.father_lastname;
    const mother_lastname = user.mother_lastname === null ? "" : user.mother_lastname;
    const first_name = user.first_name === null ? "" : user.first_name;
    const second_name = user.second_name === null ? "" : user.second_name;

    const complete_name = `${first_name} ${second_name} ${father_lastname} ${mother_lastname}`
    return complete_name
}

export async function SendEmail(user: User) {

    if (user?.id) {
        const pdfData = {
            complete_name: adapterUserCompleteName(user),
            date: new Date().toISOString()
        }

        const service = PdfGeneratorService();
        const base64PDF = await service.generateRegisterCertificateBase64(pdfData);

        const body = {
            email: user.email,
            dni: user.dni,
            password: user.password,
            base64PDF
        }

        fetch(`${process.env.REACT_APP_API_URL}email/register`, {
            method: 'POST',
            headers: API_HEADER,
            body: JSON.stringify(body)
        })
    }
}

export async function SendPoliticEmail() {
    const user_json = JSON.parse(localStorage.getItem('asg_user') ?? '{}')

    if (user_json?.id) {
        const body = {
            email: user_json.email,
            dni: user_json.dni,
            first_name: user_json.first_name,
            father_lastname: user_json.father_lastname,
            mother_lastname: user_json.mother_lastname
        }

        fetch(`${process.env.REACT_APP_API_URL}email/acceptPolitics`, {
            method: 'POST',
            headers: {
                ...API_HEADER,
                Authorization: `Bearer ${Cookies.get(ACCESS_TOKEN)}`
            },
            body: JSON.stringify(body)
        })
    }

}

export async function SendPoliticSingleEmail(politic: IPoliticAdapterResponse) {
    const user_json = JSON.parse(localStorage.getItem('asg_user') ?? '{}')

    if (user_json?.id) {

        const body = {
            email: user_json.email,
            first_name: user_json.first_name,
            father_lastname: user_json.father_lastname,
            mother_lastname: user_json.mother_lastname,
            politic
        }

        fetch(`${process.env.REACT_APP_API_URL}email/historyPolitic`, {
            method: 'POST',
            headers: {
                ...API_HEADER,
                Authorization: `Bearer ${Cookies.get(ACCESS_TOKEN)}`
            },
            body: JSON.stringify(body)
        })
    }

}

export async function SendCourseCertificate() {
    const user_json = JSON.parse(localStorage.getItem('asg_user') ?? '{}')
    const course_json = JSON.parse(localStorage.getItem('asg_course') ?? '{}')

    if (user_json?.id && course_json?.id) {
        const service = PdfGeneratorService();
        const pdfData = {
            complete_name: adapterUserCompleteName(user_json),
            name: course_json.name,
            date: course_json.date || new Date().toISOString()
        }
        const base64PDF = await service.generateCertificateBase64(pdfData);

        const body = {
            email: user_json.email,
            first_name: user_json.first_name,
            father_lastname: user_json.father_lastname,
            mother_lastname: user_json.mother_lastname,
            course: course_json,
            base64PDF
        }

        fetch(`${process.env.REACT_APP_API_URL}email/certificated`, {
            method: 'POST',
            headers: {
                ...API_HEADER,
                Authorization: `Bearer ${Cookies.get(ACCESS_TOKEN)}`
            },
            body: JSON.stringify(body)
        })
    }

}